import "../css/tailwind.css";
import "../scss/app.scss";
import "../css/all.min.css";

import { initApp } from "./core/init";

initApp();

// Helper function
let domReady = (cb) => {
  document.readyState === "interactive" || document.readyState === "complete"
    ? cb()
    : document.addEventListener("DOMContentLoaded", cb);
};

domReady(() => {
  // Display body when DOM is loaded
  document.body.style.backgroundColor = "#fff1d6";
  document.body.style.visibility = "visible";
});